export const BASE = {
  name: 'site',
  path: '/site',
};

export const LIST = {
  name: 'site.list',
  path: `${BASE.path}/list`,
};

export const CREATE = {
  name: 'site.create',
  path: `${BASE.path}/create`,
};

export const CREATE_ORGANIZATION = {
  name: 'site.createOrganization',
  path: `${BASE.path}/create-organization`,
};

export const SETTINGS = {
  name: 'site.settings',
  path: `${BASE.path}/:siteId/settings`,
};
